// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/svg/leftBannerSplash.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/consultantion-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/contact-map-background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
    width: 100%;
    max-width: 1440px;
    display: flex;
    gap: 8%;
    justify-content: center;
    padding: 100px 0px 30px 0px;
    margin-bottom: 30px;
}

.style_header__deets__rGe49 {
    width: 50%;
    max-width: 500px;
    padding: 30px 0px;
}

.style_header__deets__rGe49 h2 {
    margin: 10px 0px;
}

.style_header__deets__rGe49 span {
    font-weight: 400;
    color: var(--grey-07);
}

.style_header__deets__rGe49 p {
    margin-bottom: 20px;
}

.style_header__image__c1qTx {
    width: 50%;
    max-width: 590px;
    border-radius: 8px;
    position: relative;
    z-index: 2;
}

.style_header__image_badge__h-DPT {
    border-radius: 4px;
    padding: 10px 17px 9px 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    position: absolute;
    right: 0;
    top: -30px;
    z-index: 3;
    box-shadow: 0px 6px 8.9px 0px #00254924;
    background-color: var(--neutrals-white);
    border: 1px solid #E7F2F3;
}

.style_header__image_badge__h-DPT p {
    font-size: 10px;
    line-height: 1.4;
    margin: 0;
}

.style_header__image_badge__h-DPT p:last-of-type {
    font-size: 13px;
    font-weight: 500;
}

.style_header__image__c1qTx::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: -130px;
    left: -150px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    z-index: -1;
}

.style_header__image__c1qTx::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: -60px;
    left: -140px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position-y: bottom;
    z-index: -1;
}

.style_header__image__c1qTx img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 2;
}

.style_header__leaders__bqDVH {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    margin: 30px 0px;
}

.style_header__leaders__bqDVH p {
    color: var(--grey-07);
}

.style_header__leaders_images__yy5OY {
    display: flex;
    gap: 50px;
    flex-wrap: wrap;
    justify-content: center;
}

.style_header__leaders_images__yy5OY>img {
    width: auto;
    height: 50px;
    opacity: 0.7;
    filter: grayscale(100%);
}

.style_header__leaders_images__yy5OY>img:hover {
    opacity: 1;
    filter: grayscale(0);
}

.style_whoWeAre__7As-T {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    background-color: var(--grey-06);
}

.style_whoWeAre__7As-T * {
    color: var(--white);
    margin: 0;
}

.style_whoWeAre__7As-T .style_small__iwJUt {
    color: var(--primary-01);
}

.style_whoWeAre__wrapper__IxlLu {
    width: 93%;
    display: flex;
    gap: 10%;
    justify-content: flex-end;
}

.style_whoWeAre__deets__m6Ii1 {
    width: 53%;
    padding-top: 50px;
}

.style_whoWeAre__image__qDDiF {
    width: 40%;
}

.style_whoWeAre__image__qDDiF img {
    width: 100%;
}

.style_whoWeAre__deets__m6Ii1 h3 {
    margin: 5px 0px 7px 0px;
}

.style_whoWeAre__deets_strip__KoB4f {
    padding: 15px 20px;
    border-radius: 4px;
    margin-bottom: 20px;
    cursor: pointer;
    border: 1px solid var(--primary-01);
}

.style_whoWeAre__deets_strip__KoB4f h4 {
    margin: 5px 0px 7px 0px;
}

.style_whoWeAre__deets_strip__KoB4f p {
    line-height: 1.6;
    margin: 0;
}

.style_activated__928uO {
    background-color: var(--primary-01);
}

.style_services__spZ6q {
    position: relative;
    height: auto;
    padding-bottom: 10%;
}

.style_services__deets__YICLJ {
    width: 100%;
    min-width: 250px;
    max-width: 780px;
    text-align: center;
    margin: 80px auto 0px auto;
}

.style_services__deets__YICLJ>h3 {
    margin: 0px;
}

.style_services__deets__YICLJ>p {
    margin-bottom: 10px;
}

.style_hightlights__W0TKW {
    color: var(--primary-01);
}

.style_services__cards__1H2yD {
    display: flex;
    gap: 25px;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 40px;
}

.style_consultation__5OQjp {
    width: 100%;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, rgba(30, 30, 28, 0.7) 0%, #1E1E1C 100%);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

}

.style_consultation__deets__gqrYR {
    width: 53%;
    max-width: 780px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    text-align: center;
}

.style_consultation__5OQjp h2 {
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 10px;
}

.style_consultation__5OQjp h2,
.style_consultation__5OQjp p {
    color: var(--white);
}

.style_contact__form__81XUQ {
    width: 100%;
    display: flex;
    position: relative;
    align-items: center;
    margin-bottom: 10px;
    justify-content: center;
    padding: 60px 0px;
    background-color: var(--grey-01);
}

.style_contact__form_wrapper__iBL4m {
    width: 80%;
    display: flex;
    max-width: 1200px;
    position: relative;
    align-items: center;
    flex-direction: row;
    justify-content: center;
}

.style_contact__form_content__HZbKw {
    width: 50%;
    max-width: 644px;
    min-width: 466px;
    height: 655px;
    position: relative;
    margin-right: -70px;
    border-radius: 8px;
    background-color: var(--neutrals-white);
    box-shadow: 4px 4px 76.7px 0px var(--grey-08);
    z-index: 2;
}

.style_contact__form_content__HZbKw form {
    padding: 0px 30px 30px 30px;
}

.style_contact__form_content__HZbKw .style_double__input__v3sw3>div {
    width: 50%;
}

.style_contact__form__81XUQ .style_double__input__v3sw3 {
    display: flex;
    gap: 20px;
    margin-bottom: 15px;
}

.style_contact__form__81XUQ textarea {
    width: 100%;
    height: 120px;
    margin-bottom: 15px;
}

.style_contact__form_content__HZbKw button {
    width: 100%;
    display: flex;
    justify-content: center;
}

.style_contact__form_content__HZbKw .style_contact__form_deets__84Euk {
    text-align: center;
    padding: 100px;
    padding: 15px 50px 20px 50px;
}

.style_contact__form_deets__84Euk h4 {
    margin-bottom: 10px;
    font-size: 32px;
}

.style_contact__form_deets__84Euk h4,
.style_contact__form_deets__84Euk p {
    margin-top: 5px;
}

.style_contact__form_image__YcKjw {
    width: 50%;
    max-width: 644px;
    height: 755px;
}

.style_contact__form_image__YcKjw img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.style_contact__map__mvNdi {
    width: 100%;
    height: 600px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.style_contact__map_wrapper__wifSV {
    width: 75%;
    height: 450px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.style_contact__map_wrapper_map__5KeaP {
    width: 60%;
    min-width: 340px;
    height: inherit;
    background-color: #fcfcfc;
}

.style_contact__map_wrapper_deets__N22tk {
    width: 33%;
    height: 300px;
}

.style_contact__map_wrapper_deets__N22tk h4 {
    margin: 0;
    font-size: 30px;
}

.style_contact__map_wrapper_deets__N22tk p:not(.style_hightlights__W0TKW) {
    margin-bottom: 8px;
}

.style_contact__map_wrapper_deets__N22tk p:not(.style_hightlights__W0TKW, .style_contact__map_address_title__zeC5a) {
    width: 200px;
}

.style_contact__map_wrapper_deets__N22tk .style_contact__map_address_title__zeC5a {
    font-weight: 700;
}



@media (max-width: 768px) {

    header {
        gap: 0px;
        padding: 70px 0px 0px 0px;
        flex-wrap: wrap-reverse;
    }

    .style_header__deets__rGe49 {
        width: 93%;
        max-width: 600px;
    }

    .style_header__image__c1qTx {
        width: 90vw;
    }

    .style_whoWeAre__7As-T {
        justify-content: center;
    }

    .style_whoWeAre__wrapper__IxlLu {
        flex-wrap: wrap;
        justify-content: center;
    }

    .style_whoWeAre__deets__m6Ii1 {
        width: 90%;
        margin-bottom: 50px;
    }

    .style_whoWeAre__image__qDDiF {
        width: 90%;
        padding-bottom: 50px;
    }

    .style_consultation__deets__gqrYR {
        width: 93%;
    }

    .style_contact__form__81XUQ {
        padding: 0px 0px 40px 0px;
    }

    .style_contact__form_wrapper__iBL4m {
        width: 100%;
        flex-direction: column-reverse;
    }

    .style_contact__form_image__YcKjw {
        width: 100%;
        max-width: 768px;
        height: 501px;
    }

    .style_contact__form_content__HZbKw {
        width: 95%;
        max-width: 645px;
        min-width: 250px;
        height: auto;
        margin-top: -355px;
        margin-right: 0px;
    }

    .style_contact__form_content__HZbKw .style_double__input__v3sw3>div {
        width: 100%;
    }

    .style_double__input__v3sw3 {
        flex-direction: column;
    }

    .style_contact__map__mvNdi {
        height: auto;
    }

    .style_contact__map_wrapper__wifSV {
        width: 100%;
        height: auto;
        flex-direction: column-reverse;
    }

    .style_contact__map_wrapper_deets__N22tk {
        width: 83%;
    }

    .style_contact__map_wrapper_map__5KeaP {
        width: 84%;
        min-width: 250px;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/home/style.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,OAAO;IACP,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,uCAAuC;IACvC,uCAAuC;IACvC,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yDAA4D;IAC5D,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,yDAA4D;IAC5D,4BAA4B;IAC5B,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2EAA2E;IAC3E,yDAAkE;IAClE,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;;AAE1B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,uCAAuC;IACvC,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yDAAqE;AACzE;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;;;AAIA;;IAEI;QACI,QAAQ;QACR,yBAAyB;QACzB,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,oBAAoB;IACxB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,8BAA8B;IAClC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;AAEJ","sourcesContent":["header {\n    width: 100%;\n    max-width: 1440px;\n    display: flex;\n    gap: 8%;\n    justify-content: center;\n    padding: 100px 0px 30px 0px;\n    margin-bottom: 30px;\n}\n\n.header__deets {\n    width: 50%;\n    max-width: 500px;\n    padding: 30px 0px;\n}\n\n.header__deets h2 {\n    margin: 10px 0px;\n}\n\n.header__deets span {\n    font-weight: 400;\n    color: var(--grey-07);\n}\n\n.header__deets p {\n    margin-bottom: 20px;\n}\n\n.header__image {\n    width: 50%;\n    max-width: 590px;\n    border-radius: 8px;\n    position: relative;\n    z-index: 2;\n}\n\n.header__image_badge {\n    border-radius: 4px;\n    padding: 10px 17px 9px 8px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    position: absolute;\n    right: 0;\n    top: -30px;\n    z-index: 3;\n    box-shadow: 0px 6px 8.9px 0px #00254924;\n    background-color: var(--neutrals-white);\n    border: 1px solid #E7F2F3;\n}\n\n.header__image_badge p {\n    font-size: 10px;\n    line-height: 1.4;\n    margin: 0;\n}\n\n.header__image_badge p:last-of-type {\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.header__image::before {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: -130px;\n    left: -150px;\n    background-image: url(../../assets/svg/leftBannerSplash.svg);\n    background-repeat: no-repeat;\n    z-index: -1;\n}\n\n.header__image::after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    bottom: -60px;\n    left: -140px;\n    background-image: url(../../assets/svg/leftBannerSplash.svg);\n    background-repeat: no-repeat;\n    background-position-y: bottom;\n    z-index: -1;\n}\n\n.header__image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    z-index: 2;\n}\n\n.header__leaders {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 20px;\n    margin: 30px 0px;\n}\n\n.header__leaders p {\n    color: var(--grey-07);\n}\n\n.header__leaders_images {\n    display: flex;\n    gap: 50px;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n\n.header__leaders_images>img {\n    width: auto;\n    height: 50px;\n    opacity: 0.7;\n    filter: grayscale(100%);\n}\n\n.header__leaders_images>img:hover {\n    opacity: 1;\n    filter: grayscale(0);\n}\n\n.whoWeAre {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    background-color: var(--grey-06);\n}\n\n.whoWeAre * {\n    color: var(--white);\n    margin: 0;\n}\n\n.whoWeAre .small {\n    color: var(--primary-01);\n}\n\n.whoWeAre__wrapper {\n    width: 93%;\n    display: flex;\n    gap: 10%;\n    justify-content: flex-end;\n}\n\n.whoWeAre__deets {\n    width: 53%;\n    padding-top: 50px;\n}\n\n.whoWeAre__image {\n    width: 40%;\n}\n\n.whoWeAre__image img {\n    width: 100%;\n}\n\n.whoWeAre__deets h3 {\n    margin: 5px 0px 7px 0px;\n}\n\n.whoWeAre__deets_strip {\n    padding: 15px 20px;\n    border-radius: 4px;\n    margin-bottom: 20px;\n    cursor: pointer;\n    border: 1px solid var(--primary-01);\n}\n\n.whoWeAre__deets_strip h4 {\n    margin: 5px 0px 7px 0px;\n}\n\n.whoWeAre__deets_strip p {\n    line-height: 1.6;\n    margin: 0;\n}\n\n.activated {\n    background-color: var(--primary-01);\n}\n\n.services {\n    position: relative;\n    height: auto;\n    padding-bottom: 10%;\n}\n\n.services__deets {\n    width: 100%;\n    min-width: 250px;\n    max-width: 780px;\n    text-align: center;\n    margin: 80px auto 0px auto;\n}\n\n.services__deets>h3 {\n    margin: 0px;\n}\n\n.services__deets>p {\n    margin-bottom: 10px;\n}\n\n.hightlights {\n    color: var(--primary-01);\n}\n\n.services__cards {\n    display: flex;\n    gap: 25px;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-top: 40px;\n}\n\n.consultation {\n    width: 100%;\n    min-height: 400px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: linear-gradient(180deg, rgba(30, 30, 28, 0.7) 0%, #1E1E1C 100%);\n    background-image: url(../../assets/images/consultantion-image.png);\n    background-attachment: fixed;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n\n}\n\n.consultation__deets {\n    width: 53%;\n    max-width: 780px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    margin: auto;\n    text-align: center;\n}\n\n.consultation h2 {\n    font-size: 36px;\n    font-weight: 700;\n    margin-bottom: 10px;\n}\n\n.consultation h2,\n.consultation p {\n    color: var(--white);\n}\n\n.contact__form {\n    width: 100%;\n    display: flex;\n    position: relative;\n    align-items: center;\n    margin-bottom: 10px;\n    justify-content: center;\n    padding: 60px 0px;\n    background-color: var(--grey-01);\n}\n\n.contact__form_wrapper {\n    width: 80%;\n    display: flex;\n    max-width: 1200px;\n    position: relative;\n    align-items: center;\n    flex-direction: row;\n    justify-content: center;\n}\n\n.contact__form_content {\n    width: 50%;\n    max-width: 644px;\n    min-width: 466px;\n    height: 655px;\n    position: relative;\n    margin-right: -70px;\n    border-radius: 8px;\n    background-color: var(--neutrals-white);\n    box-shadow: 4px 4px 76.7px 0px var(--grey-08);\n    z-index: 2;\n}\n\n.contact__form_content form {\n    padding: 0px 30px 30px 30px;\n}\n\n.contact__form_content .double__input>div {\n    width: 50%;\n}\n\n.contact__form .double__input {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 15px;\n}\n\n.contact__form textarea {\n    width: 100%;\n    height: 120px;\n    margin-bottom: 15px;\n}\n\n.contact__form_content button {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n\n.contact__form_content .contact__form_deets {\n    text-align: center;\n    padding: 100px;\n    padding: 15px 50px 20px 50px;\n}\n\n.contact__form_deets h4 {\n    margin-bottom: 10px;\n    font-size: 32px;\n}\n\n.contact__form_deets h4,\n.contact__form_deets p {\n    margin-top: 5px;\n}\n\n.contact__form_image {\n    width: 50%;\n    max-width: 644px;\n    height: 755px;\n}\n\n.contact__form_image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.contact__map {\n    width: 100%;\n    height: 600px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-image: url(../../assets/images/contact-map-background.png);\n}\n\n.contact__map_wrapper {\n    width: 75%;\n    height: 450px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.contact__map_wrapper_map {\n    width: 60%;\n    min-width: 340px;\n    height: inherit;\n    background-color: #fcfcfc;\n}\n\n.contact__map_wrapper_deets {\n    width: 33%;\n    height: 300px;\n}\n\n.contact__map_wrapper_deets h4 {\n    margin: 0;\n    font-size: 30px;\n}\n\n.contact__map_wrapper_deets p:not(.hightlights) {\n    margin-bottom: 8px;\n}\n\n.contact__map_wrapper_deets p:not(.hightlights, .contact__map_address_title) {\n    width: 200px;\n}\n\n.contact__map_wrapper_deets .contact__map_address_title {\n    font-weight: 700;\n}\n\n\n\n@media (max-width: 768px) {\n\n    header {\n        gap: 0px;\n        padding: 70px 0px 0px 0px;\n        flex-wrap: wrap-reverse;\n    }\n\n    .header__deets {\n        width: 93%;\n        max-width: 600px;\n    }\n\n    .header__image {\n        width: 90vw;\n    }\n\n    .whoWeAre {\n        justify-content: center;\n    }\n\n    .whoWeAre__wrapper {\n        flex-wrap: wrap;\n        justify-content: center;\n    }\n\n    .whoWeAre__deets {\n        width: 90%;\n        margin-bottom: 50px;\n    }\n\n    .whoWeAre__image {\n        width: 90%;\n        padding-bottom: 50px;\n    }\n\n    .consultation__deets {\n        width: 93%;\n    }\n\n    .contact__form {\n        padding: 0px 0px 40px 0px;\n    }\n\n    .contact__form_wrapper {\n        width: 100%;\n        flex-direction: column-reverse;\n    }\n\n    .contact__form_image {\n        width: 100%;\n        max-width: 768px;\n        height: 501px;\n    }\n\n    .contact__form_content {\n        width: 95%;\n        max-width: 645px;\n        min-width: 250px;\n        height: auto;\n        margin-top: -355px;\n        margin-right: 0px;\n    }\n\n    .contact__form_content .double__input>div {\n        width: 100%;\n    }\n\n    .double__input {\n        flex-direction: column;\n    }\n\n    .contact__map {\n        height: auto;\n    }\n\n    .contact__map_wrapper {\n        width: 100%;\n        height: auto;\n        flex-direction: column-reverse;\n    }\n\n    .contact__map_wrapper_deets {\n        width: 83%;\n    }\n\n    .contact__map_wrapper_map {\n        width: 84%;\n        min-width: 250px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header__deets": `style_header__deets__rGe49`,
	"header__image": `style_header__image__c1qTx`,
	"header__image_badge": `style_header__image_badge__h-DPT`,
	"header__leaders": `style_header__leaders__bqDVH`,
	"header__leaders_images": `style_header__leaders_images__yy5OY`,
	"whoWeAre": `style_whoWeAre__7As-T`,
	"small": `style_small__iwJUt`,
	"whoWeAre__wrapper": `style_whoWeAre__wrapper__IxlLu`,
	"whoWeAre__deets": `style_whoWeAre__deets__m6Ii1`,
	"whoWeAre__image": `style_whoWeAre__image__qDDiF`,
	"whoWeAre__deets_strip": `style_whoWeAre__deets_strip__KoB4f`,
	"activated": `style_activated__928uO`,
	"services": `style_services__spZ6q`,
	"services__deets": `style_services__deets__YICLJ`,
	"hightlights": `style_hightlights__W0TKW`,
	"services__cards": `style_services__cards__1H2yD`,
	"consultation": `style_consultation__5OQjp`,
	"consultation__deets": `style_consultation__deets__gqrYR`,
	"contact__form": `style_contact__form__81XUQ`,
	"contact__form_wrapper": `style_contact__form_wrapper__iBL4m`,
	"contact__form_content": `style_contact__form_content__HZbKw`,
	"double__input": `style_double__input__v3sw3`,
	"contact__form_deets": `style_contact__form_deets__84Euk`,
	"contact__form_image": `style_contact__form_image__YcKjw`,
	"contact__map": `style_contact__map__mvNdi`,
	"contact__map_wrapper": `style_contact__map_wrapper__wifSV`,
	"contact__map_wrapper_map": `style_contact__map_wrapper_map__5KeaP`,
	"contact__map_wrapper_deets": `style_contact__map_wrapper_deets__N22tk`,
	"contact__map_address_title": `style_contact__map_address_title__zeC5a`
};
export default ___CSS_LOADER_EXPORT___;
